import "core-js/modules/es6.object.assign.js";
import "core-js/modules/es6.function.bind.js";
import "core-js/modules/es6.object.assign.js";

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

import * as React from "react";

function Rss(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M4.5 4.5H5c7.996 0 14.5 6.504 14.5 14.5v.5h-2.867V19c0-6.414-5.219-11.633-11.633-11.633h-.5V4.5zm1 1.01v.866c6.57.257 11.867 5.554 12.124 12.125h.867C18.233 11.453 12.547 5.767 5.5 5.509zm-1 3.657H5c5.423 0 9.833 4.41 9.833 9.834v.5h-2.866V19c0-3.842-3.126-6.968-6.967-6.968h-.5V9.167zm1 1.014v.868a7.979 7.979 0 017.451 7.452h.868c-.25-4.474-3.846-8.07-8.319-8.32zm-1 6.952a2.367 2.367 0 114.733 0 2.367 2.367 0 01-4.733 0zm2.367-1.366a1.367 1.367 0 100 2.733 1.367 1.367 0 000-2.733z",
    clipRule: "evenodd"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Rss);
export default ForwardRef;